
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {}
})
export default class InternalError extends Vue {
  @Prop()
  private error!: Error;

  protected redirectHome(): void {
    window.location.href = '/';
  }

  protected get errorMessage(): string {
    return `common.InternalError.${this.error?.message}`;
  }
}
